// src/components/users/UserFiltersPanel.tsx
// Filter panel for users

import React from 'react';
import { X } from 'lucide-react';
import { UserFilters } from '../../types/user';
import './UserTable.css';

interface UserFiltersPanelProps {
  filters: UserFilters;
  onChange: (filters: Partial<UserFilters>) => void;
  onClose: () => void;
}

const UserFiltersPanel: React.FC<UserFiltersPanelProps> = ({
  filters,
  onChange,
  onClose,
}) => {
  const handleReset = () => {
    onChange({
      role: '',
      status: '',
      isVerified: null,
      sortBy: 'createdAt',
      sortOrder: 'desc',
    });
  };

  return (
    <div className="filters-panel">
      <div className="filters-header">
        <h3>Filters</h3>
        <button onClick={onClose} className="btn-close">
          <X size={20} />
        </button>
      </div>

      <div className="filters-content">
        {/* Role Filter */}
        <div className="filter-group">
          <label>User Role</label>
          <select
            value={filters.role}
            onChange={(e) => onChange({ role: e.target.value })}
          >
            <option value="">All Roles</option>
            <option value="passenger">Passenger</option>
            <option value="driver">Driver</option>
            <option value="both">Both (Driver + Passenger)</option>
          </select>
        </div>

        {/* Status Filter */}
        <div className="filter-group">
          <label>Status</label>
          <select
            value={filters.status}
            onChange={(e) => onChange({ status: e.target.value })}
          >
            <option value="">All Statuses</option>
            <option value="active">Active</option>
            <option value="suspended">Suspended</option>
            <option value="banned">Banned</option>
          </select>
        </div>

        {/* Verification Filter */}
        <div className="filter-group">
          <label>Verification Status</label>
          <select
            value={filters.isVerified === null ? '' : filters.isVerified.toString()}
            onChange={(e) =>
              onChange({
                isVerified: e.target.value === '' ? null : e.target.value === 'true',
              })
            }
          >
            <option value="">All</option>
            <option value="true">Verified</option>
            <option value="false">Unverified</option>
          </select>
        </div>

        {/* Sort By */}
        <div className="filter-group">
          <label>Sort By</label>
          <select
            value={filters.sortBy}
            onChange={(e) => onChange({ sortBy: e.target.value })}
          >
            <option value="createdAt">Registration Date</option>
            <option value="firstName">First Name</option>
            <option value="lastName">Last Name</option>
            <option value="email">Email</option>
            <option value="lastLoginAt">Last Login</option>
          </select>
        </div>

        {/* Sort Order */}
        <div className="filter-group">
          <label>Sort Order</label>
          <select
            value={filters.sortOrder}
            onChange={(e) => onChange({ sortOrder: e.target.value as 'asc' | 'desc' })}
          >
            <option value="desc">Descending</option>
            <option value="asc">Ascending</option>
          </select>
        </div>
      </div>

      <div className="filters-footer">
        <button onClick={handleReset} className="btn-secondary">
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default UserFiltersPanel;